import { render, staticRenderFns } from "./imports_wizard.vue?vue&type=template&id=a8cd38cc&scoped=true&"
import script from "./imports_wizard.vue?vue&type=script&lang=js&"
export * from "./imports_wizard.vue?vue&type=script&lang=js&"
import style0 from "./imports_wizard.vue?vue&type=style&index=0&id=a8cd38cc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8cd38cc",
  null
  
)

export default component.exports